import { Validator } from '@vista-digital/validator';
import { defaultSeatPickerAreaLabelsConfig, seatPickerAreaLabelsConfigValidator } from './area-labels';
import { defaultSeatPickerLegendConfig, seatPickerLegendConfigValidator } from './legend';
import { defaultSeatPickerNavigationConfig, seatPickerNavigationConfigValidator } from './navigation';
import { defaultSeatPickerNotificationConfig, seatPickerNotificationConfigValidator } from './notification';
import { defaultSeatPickerRowLabelsConfig, seatPickerRowLabelsConfigValidator } from './row-labels';
import { defaultSeatPickerScreenConfig, seatPickerScreenConfigValidator } from './screen';
import { defaultSeatPickerSelectionRulesConfig, seatPickerSelectionRulesConfigValidator } from './seat-selection-rules';
import { defaultSeatPickerSeatsConfig, seatPickerSeatsConfigValidator } from './seats';
/**
 * Default configuration options for the Seat Picker component.
 */
export const defaultSeatPickerConfig = {
    screen: defaultSeatPickerScreenConfig,
    seats: defaultSeatPickerSeatsConfig,
    rowLabels: defaultSeatPickerRowLabelsConfig,
    areaLabels: defaultSeatPickerAreaLabelsConfig,
    legend: defaultSeatPickerLegendConfig,
    notification: defaultSeatPickerNotificationConfig,
    navigation: defaultSeatPickerNavigationConfig,
    selectionRules: defaultSeatPickerSelectionRulesConfig
};
export const seatPickerConfigValidatorSchema = {
    screen: seatPickerScreenConfigValidator,
    seats: seatPickerSeatsConfigValidator,
    rowLabels: seatPickerRowLabelsConfigValidator,
    areaLabels: seatPickerAreaLabelsConfigValidator,
    legend: seatPickerLegendConfigValidator,
    notification: seatPickerNotificationConfigValidator,
    navigation: seatPickerNavigationConfigValidator,
    selectionRules: seatPickerSelectionRulesConfigValidator
};
export const seatPickerConfigValidator = Validator.object(seatPickerConfigValidatorSchema);
